.breadcrumb {
  font-size: 14px;
  color: #505050; /* Darker text for better readability */
  padding: 0.76em;
  text-decoration: none;
}

.breadcrumb .inactive a {
  color: #666; /* Slightly darker gray for links */
  text-decoration: none;
}

.breadcrumb .inactive a:hover {
  color: #505050 !important; /* Darker on hover */
  text-decoration: none;
}

.breadcrumb .active,
.breadcrumb .active a {
  color: #505050 !important; /* Strong contrast for active item */
  font-weight: 300;
  text-decoration: none;
}

@media (max-width: 480px) {
  .breadcrumb {
    font-size: 13px;
  }
}
